import React from "react";
import ProductCard from "../conponents/ProductCard";

const productArray = [
  {
    logo: "/jobninja.svg",
    title: "The Ultimate Casual Job Platform",
    descri:
      "Find flexible employment effortlessly with JobNinja. Designed for individuals seeking casual work and businesses in need of temporary staff, Job Ninja makes job hunting and hiring a breeze.",
    status: "Launched",
    siteUrl: "www.jobninja.com.au",
    pic: "/job-ninja-app.png",
  },

  {
    logo: "/saleswin-logo.svg",
    title: "Empowering Sales Professionals",
    descri:
      "Maximise your sales performance with SalesWin. Tailored for sales professionals, this platform offers everything you need to outperform in the competitive market.",
    status: "Launched",
    siteUrl: "www.saleswin.com",
    pic: "/saleswin.svg",
  },

  {
    logo: "/neztdo-logo.svg",
    title: "Streamline Your Workflow",
    descri:
      "Transform your team's productivity with Neztdo. Our workflow management tool simplifies processes, ensuring smooth collaboration and efficiency.",
    status: " Launching soon",
    siteUrl: "www.neztdo.com",
    pic: "/neztdo.png",
  },

  {
    logo: "/cach-logo.png",
    title: "Your Personalised Social Network",
    descri:
      "Experience social networking on your terms with Catch. Tailor your feed to match your interests and connect with content and communities that matter most to you.",
    status: "Launching soon",
    siteUrl: "www.cach.co",
    pic: "/cach.svg",
  },

  {
    logo: "/nearit-logo.png",
    title: "Bringing Connections Closer Than Ever",
    descri:
      "Discover and connect with the world around you using Nearit. From finding local events to connecting with friends nearby, Nearit brings your world closer.",
    status: "Launching soon",
    siteUrl: null,
    pic: null,
  },
];

const Product = () => {
  return (
    <div className="flex flex-col justify-center items-center bg-gradient-to-b from-gray-200 to-[#A9B9C5] py-20">
      <div className="w-[80%] md:w-[70%] flex flex-col justify-center items-center">
        <p className="text-5xl md:text-6xl font-bold font-syne mt-10 mb-6 text-center">
          Our Products
        </p>
        <p className="text-[20px] font-medium text-center w-[80%] leading-[2rem]">
          Explore our suite of innovative software solutions, each designed to
          enhance your work, amplify your team's potential, and enrich your
          connectivity. Whether you're navigating the job market, looking to
          elevate your sales performance, seeking a more personalised social
          network experience, or aiming to streamline your workflow, our
          products are here to revolutionise the way you approach daily tasks.
        </p>
      </div>

      <div className="flex flex-col justify-center items-center gap-10 pt-40">
        {productArray.map((item) => {
          return <ProductCard productArray={item} />;
        })}
      </div>
    </div>
  );
};

export default Product;
